import { createFrontendModule } from '@backstage/frontend-plugin-api';
import homePlugin from '@backstage/plugin-home/alpha';
import { homeLandingPageLayout } from '@internal/backstage-plugin-landing-pages';

const homePageOverride = homePlugin.getExtension('page:home').override({
  params: {
    path: '/',
  },
});

/** Bundles all Home overrides into a single frontend module. */
export const homePluginOverride = createFrontendModule({
  pluginId: 'home',
  extensions: [homePageOverride, homeLandingPageLayout],
});
